<template>
  <div>
    <div class="flex justify-between mb-8">
      <h2 class="text-2xl font-bold">Marketer Data</h2>
    </div>

    <div v-if="fetchingParameterNames" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>

    <ul v-else class="my-12">
      <li v-for="parameter in parameters" :key="parameter.name">
        <div class="flex bg-white mb-1">
          <div class="flex-1 flex justify-between py-2 px-4">
            {{ parameter.value }}
          </div>
          <base-button @click="parameter.open = !parameter.open">
            <icon-edit />
          </base-button>
        </div>
        <AdminMarketerDataForm
          v-if="parameter.open"
          :parameter="parameter"
          @saved="parameter.open = false"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AdminMarketerDataForm from './components/AdminMarketerDataForm';

export default {
  components: { AdminMarketerDataForm },
  data() {
    return {
      parameters: [],
    };
  },
  watch: {
    parameterNames(parameterNames) {
      this.getParameters(parameterNames);
    },
  },
  computed: {
    ...mapState('company', ['fetchingParameterNames', 'parameterNames']),
  },
  created() {
    this.getParameters(this.parameterNames);
  },
  methods: {
    getParameters(names) {
      this.parameters = Object.entries(names).flatMap(([key, value]) => {
        if (key === 'id') return [];

        const label = key
          .replace('_', ' ')
          .split(' ')
          .map(
            ([firstChar, ...rest]) =>
              firstChar.toUpperCase() + rest.join('').toLowerCase()
          )
          .join(' ');

        return [
          {
            name: key,
            value: value || label,
            open: false,
          },
        ];
      });
    },
  },
};
</script>
